import React, { Component } from "react";
import { StoryLine } from "./type";

type Props = {
  storyline: StoryLine;
  storylineName: string;
  storylineWidth: number;
  storylineColor: string;
};

type State = Record<string, unknown>;

export default class StorylinePath extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <path
        d={generateSmoothSegment(this.props.storyline)}
        stroke={`${this.props.storylineColor}`}
        fill="none"
        strokeWidth={this.props.storylineWidth}
      />
    );
  }
}

function generateSmoothSegment(line: number[][][]) {
  let path = `M ${line[0][0][0]} ${line[0][0][1]} L ${line[0][1][0]} ${line[0][1][1]}`;
  for (let i = 0; i < line.length - 1; i++) {
    path += ` L ${line[i][2][0]} ${line[i][2][1]} C ${line[i][3][0]} ${
      line[i][3][1]
    } ${line[i + 1][0][0]} ${line[i + 1][0][1]} ${line[i + 1][1][0]} ${
      line[i + 1][1][1]
    }`;
  }
  const linesNum = line.length;
  path += ` L ${line[linesNum - 1][2][0]} ${line[linesNum - 1][2][1]} L ${
    line[linesNum - 1][3][0]
  } ${line[linesNum - 1][3][1]}`;
  return path;
}
